import { Separator, ToggleGroup, ToggleGroupItem } from '~/components/ui'

type MapRailFilterProps = {
  rail?: 'true' | 'false'
  updateFilter: (key: string, value: any) => void
}

export default function MapRailFilter({
  rail,
  updateFilter,
}: MapRailFilterProps) {
  const value = rail ?? 'any'

  return (
    <div className="space-y-2">
      <Separator />
      <p className="text-sm font-semibold">Rail Served</p>
      <ToggleGroup
        type="single"
        variant="outline"
        size="sm"
        className="justify-start"
        value={value}
        onValueChange={(next) => {
          if (!next || next === 'any') {
            updateFilter('rail', undefined)
            return
          }

          updateFilter('rail', next)
        }}>
        <ToggleGroupItem value="any">Any</ToggleGroupItem>
        <ToggleGroupItem value="true">Yes</ToggleGroupItem>
        <ToggleGroupItem value="false">No</ToggleGroupItem>
      </ToggleGroup>
    </div>
  )
}
